
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/church",
      function () {
        return require("private-next-pages/church/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/church"])
      });
    }
  